import axios from '../../helpers/private.axios'



export const regenerateDocument  = ( id, data ) => {

    return axios.post(`/api/documents/doc/${id}/regenerage`, data );

}